import { useSelector } from '../../store'

export type SelectedTenant = {
  companyName?: string
  websiteUrl?: string
  industry?: string
}

export const useTenant = () => {
  return useSelector(state => state.tenants?.selectedTenant ?? null)
}
